/**
 * Updates or inserts the given child component into the given collection
 * of component definitions.
 * Criteria for updating is based on the signature of the component (its
 * prop list) and the value of the format prop (if provided by the user).
 * Format is specifically singled out for its value because this is how
 * users define what data format they want to override.
 * @param {Array<React.Component>} definitions
 * @param {React.Component} child
 */
const upsertDefinition = (definitions = [], child) => {
  const foundIdx = definitions.findIndex(def => {
    const defProps = Object.keys(def.props).sort();
    const childProps = Object.keys(child.props).sort();
    const hasSamePropList =
      JSON.stringify(defProps) === JSON.stringify(childProps);
    // if the format prop is undefined, it's okay, it's still considered
    // the same target (just a more generic one that will affect all types).
    const hasSameFormatTarget = def.props.format === child.props.format;
    return hasSamePropList && hasSameFormatTarget;
  });
  if (foundIdx > -1) {
    // update the existing component reference
    definitions[foundIdx] = child;
    return;
  }
  // otherwise add it to the list because it's new component reference
  definitions.push(child);
};

export default upsertDefinition;
